module.exports = __webpack_public_path__ + "img/event_training.31f07854.svg";